import { Form as AntdForm, Input } from "antd"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { changePassword, firebaseError } from "usecases/firebase/auth"

import { ErrorAlert, SuccessAlert } from "../../components/atoms/Alert"
import { Button } from "../../components/atoms/Button"
import { Spin } from "../../components/atoms/Spin"
import {
  Form,
  FormItem,
  FormItemCenter,
  FormTitle,
} from "../../components/atoms/form"
import { useInitializeAccountData } from "../../hooks/useInitializeAccountData"
import { useAsyncLoading } from "../../hooks/useLoading"

import type { ChangePassword } from "interfaces/ChangePasswordIF"

export const PasswordPage = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | undefined>()
  const [success, setSuccess] = useState<boolean>(false)
  const [form] = AntdForm.useForm()
  const [loading, asyncLoading] = useAsyncLoading()
  const initialize = useInitializeAccountData()
  useEffect(() => {
    asyncLoading(initialize().catch((e: any) => console.warn(e)))
  }, [])

  const onFinish = (values: unknown) => {
    const password = (values as ChangePassword).password
    const newPassword = (values as ChangePassword).newPassword
    const newPasswordConfirm = (values as ChangePassword).newPasswordConfirm
    if (newPassword !== newPasswordConfirm) {
      setSuccess(false)

      const ErrorMes = "新しいパスワードが一致しません"
      setError(ErrorMes)
      throw new Error(ErrorMes)
      return
    }
    changePassword(password, newPassword)
      .then(() => {
        setSuccess(true)
        setError("")
        form.resetFields()
      })
      .catch((e) => {
        setSuccess(false)
        const code = firebaseError(e.code, "change-password")
        code && setError(code)
      })
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo)
    setSuccess(false)
    setError(errorInfo.message)
  }

  return loading ? (
    <Spin />
  ) : (
    <Form
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      requiredMark={false}
      form={form}
    >
      <FormTitle>パスワード変更</FormTitle>
      <p>ログインに利用するパスワードを変更することができます。</p>

      <FormItem
        label="現在のパスワード"
        name="password"
        required
        rules={[
          { required: true, message: "現在のパスワードを入力してください" },
        ]}
      >
        <Input.Password maxLength={100} />
      </FormItem>

      <FormItem
        label="新しいパスワード"
        name="newPassword"
        required
        rules={[
          { required: true, message: "新しいパスワードを入力してください" },
        ]}
      >
        <Input.Password maxLength={100} />
      </FormItem>

      <FormItem
        label="新しいパスワード(確認用)"
        name="newPasswordConfirm"
        required
        rules={[
          {
            required: true,
            message: "新しいパスワード(確認用)を入力してください",
          },
        ]}
      >
        <Input.Password maxLength={100} />
      </FormItem>
      {success && <SuccessAlert>パスワードを変更しました</SuccessAlert>}
      {error && <ErrorAlert>{error}</ErrorAlert>}
      <FormItemCenter>
        <SaveButton isLoading={loading} className={"primary"} htmlType="submit">
          保存
        </SaveButton>
      </FormItemCenter>
    </Form>
  )
}

const SaveButton = styled(Button)`
  width: 12rem;
`
